export default "__VITE_ASSET__68a17cbf__"